// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3-yws","title":"Images90_title__3QbUt","images":"Images90_images__gMmnf"};